import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'
import { dataService } from '../services/dataService'
import { X, Save } from 'lucide-react'
import './AlbaranDialog.css'

export default function ProductoDialog({ producto, onClose, onGuardar }) {
  const [formData, setFormData] = useState({
    nombre: '',
    precio_base: 0,
    iva_pct: 10,
    descuento_aplicable: false,
    activo: true
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (producto) {
      setFormData(producto)
    }
  }, [producto])

  function actualizar(campo, valor) {
    setFormData(prev => ({ ...prev, [campo]: valor }))
  }

async function guardar() {
  // Validaciones
  if (!formData.nombre?.trim()) {
    alert('El nombre es obligatorio')
    return
  }
  if (!formData.precio_base || formData.precio_base <= 0) {
    alert('El precio debe ser mayor a 0')
    return
  }

  setLoading(true)

  try {
    const isNew = !producto

    const productoData = {
      ...formData,
      precio_base: Number(formData.precio_base),
      iva_pct: Number(formData.iva_pct) || 10,
      descuento_aplicable: Boolean(formData.descuento_aplicable),
      activo: Boolean(formData.activo)
    }

    // Si es nuevo, generar ID temporal para offline
    if (isNew && !navigator.onLine) {
      productoData.id = `temp_${Date.now()}_${Math.random()}`
    }

    const result = await dataService.saveProduct(productoData, isNew)

    if (result.success) {
      const mensaje = result.mode === 'offline'
        ? 'Producto guardado OFFLINE. Se sincronizará cuando haya conexión.'
        : 'Producto guardado correctamente.'
      
      alert(mensaje)
      onGuardar()
    }
  } catch (error) {
    console.error('Error guardando producto:', error)
    alert('Error al guardar: ' + error.message)
  } finally {
    setLoading(false)
  }
}

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
        <div className="dialog-header">
          <h2>{producto ? 'Editar Producto' : 'Nuevo Producto'}</h2>
          <button className="btn-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="dialog-body">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div>
              <label style={{ display: 'block', fontSize: '0.875rem', color: 'var(--muted)', marginBottom: '0.375rem' }}>
                Nombre del producto *
              </label>
              <input
                type="text"
                value={formData.nombre}
                onChange={(e) => actualizar('nombre', e.target.value)}
                placeholder="Ej: Barra de Pan"
                style={{ width: '100%', padding: '0.625rem', background: '#0e1116', border: '1px solid var(--line)', borderRadius: '6px', color: 'var(--fg)' }}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', color: 'var(--muted)', marginBottom: '0.375rem' }}>
                  Precio base (€)
                </label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={formData.precio_base}
                  onChange={(e) => actualizar('precio_base', Number(e.target.value))}
                  style={{ width: '100%', padding: '0.625rem', background: '#0e1116', border: '1px solid var(--line)', borderRadius: '6px', color: 'var(--fg)' }}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', color: 'var(--muted)', marginBottom: '0.375rem' }}>
                  IVA (%)
                </label>
                <select
                  value={formData.iva_pct}
                  onChange={(e) => actualizar('iva_pct', Number(e.target.value))}
                  style={{ width: '100%', padding: '0.625rem', background: '#0e1116', border: '1px solid var(--line)', borderRadius: '6px', color: 'var(--fg)' }}
                >
                  <option value={4}>4%</option>
                  <option value={10}>10%</option>
                  <option value={21}>21%</option>
                </select>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.75rem', background: 'rgba(45, 212, 191, 0.05)', borderRadius: '6px', border: '1px solid var(--line)' }}>
              <input
                type="checkbox"
                id="descuento_aplicable"
                checked={formData.descuento_aplicable}
                onChange={(e) => actualizar('descuento_aplicable', e.target.checked)}
              />
              <label htmlFor="descuento_aplicable" style={{ fontSize: '0.9375rem', cursor: 'pointer', flex: 1 }}>
                Aplica margen de descuento
                <div style={{ fontSize: '0.8125rem', color: 'var(--muted)', marginTop: '0.25rem' }}>
                  Si está marcado, se aplicará el descuento del cliente en este producto
                </div>
              </label>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <input
                type="checkbox"
                id="activo"
                checked={formData.activo}
                onChange={(e) => actualizar('activo', e.target.checked)}
              />
              <label htmlFor="activo" style={{ fontSize: '0.9375rem', cursor: 'pointer' }}>
                Producto activo
              </label>
            </div>
          </div>
        </div>

        <div className="dialog-footer">
          <button onClick={onClose} className="btn-secondary">Cancelar</button>
          <button onClick={guardar} disabled={loading} className="btn-primary">
            <Save size={18} /> {loading ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  )
}